import React from 'react';

export type LinkType = 'prod' | 'dev';

interface LinkProps {
    href: string;
    onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    children?: React.ReactNode;
    className?: string;
    type?: LinkType;
    dangerouslySetInnerHTML?: {
        __html: string;
    };
    tabIndex?: number;
}

const Link = ({
    href,
    children,
    onClick,
    dangerouslySetInnerHTML,
    type = 'prod',
    className = '',
    tabIndex = 0,
}: LinkProps) => {
    const onClickBase = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();

        if (type === 'prod') {
            window.history.pushState({}, '', href);
        }

        onClick(e);
        return false;
    };

    return (
        <a
            href={href}
            onClick={onClickBase}
            className={className}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            tabIndex={tabIndex}
        >
            {children}
        </a>
    );
};

export default Link;
